import { connect } from 'react-redux'

import ExportCSVButton from '@components/dashboard/ExportCSVButton'

export default connect(undefined, undefined)(ExportCSVButton)
